import React from "react";
import {
  UserGroupMutationForm,
  GroupInput
} from "routes/Manage/DeviceUsers/Shared/Forms";

export const CreateGroupModal: React.FC<{
  tenantId: string;
  deviceUsers: Array<{ name: string; id: string }>;
  urlEndPath: string;
}> = ({ tenantId, deviceUsers, urlEndPath }) => {
  return (
    <UserGroupMutationForm
      tenantId={tenantId}
      title="CREATE_DEVICE_USER_GROUP"
      description="CREATE_NEW_USER_GROUP_DESCRIPTION"
      mutationResultKey="CREATE_NEW_USER_GROUP_CONFIRM"
      urlEndPath={urlEndPath}
      deviceUsers={deviceUsers}
      GroupInput={GroupInput}
      operation="Create"
      successMessage="CREATE_USER_GROUP_SUCCESS"
      showLinkOnSuccess={true}
      errorMessage="CREATE_USER_GROUP_FAILURE"
    />
  );
};
